import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  units: [],
  loading: false,
  total: 0,
  filteredTotal: 0,
};

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;

  return {
    ...state,
    units: data,
    total,
    filteredTotal,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_SUCCESS]: onLoadSuccess,
});
